<ng-template #templateRef>
  <div class="p-inputgroup">
    <p-select #dropdownRef
              [options]="itemsSource$ | async"
              [(ngModel)]="dropdownFilterValue"
              (onChange)="filter()"
              [filter]="dropdownRef.options?.length > 5"
              dataKey="id"
              optionLabel="name"
              appendTo="body"
              [placeholder]="placeholder">
    </p-select>
    @if (isFilterApplied) {
      <button pButton
              type="button"
              icon="pi pi-times"
              (click)="cleanFilter()">
      </button>
    }
  </div>
</ng-template>